import {spawnErrorToast} from '@hm/fundamental'
import type {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {useRefraQuery} from '@refra/modules/common/hooks'
import type {ErrorResponse} from '@refra/modules/common/types'
import {logger} from '@refra/modules/common/utils'

export const DEFAULT_CUSTOMIZATIONS_PAGE = 0
export const DEFAULT_CUSTOMIZATIONS_PAGE_LIMIT = 1000

export const useRefractoryCustomizationsQuery = ({
  plantUpmId,
  page,
  limit,
  ids,
  name,
  manufacturerIds,
  activeAfter,
  enabled = true
}: {
  plantUpmId: string
  page?: number
  limit?: number
  ids?: number[]
  name?: string
  manufacturerIds?: number[]
  activeAfter?: string
  enabled?: boolean
}) => {
  const {t} = useTranslation()

  const defaultPage = page ?? DEFAULT_CUSTOMIZATIONS_PAGE
  const defaultLimit = limit ?? DEFAULT_CUSTOMIZATIONS_PAGE_LIMIT

  return useRefraQuery({
    queryKey: 'refractoriesWithCustomization',
    params: [
      {plantUpmId, page: defaultPage, limit: defaultLimit, ids, name, manufacturerIds, activeAfter}
    ],
    throwOnError: (error) => {
      const axiosError = error as AxiosError<ErrorResponse>
      const errorDetails =
        axiosError?.response?.data.detail ?? axiosError.message ?? axiosError.response?.status
      logger
        .context('useRefractoryCustomizationsQuery')
        .extras({errorDetails})
        .error('Error occurred while fetching refractory customizations')

      spawnErrorToast(t('error.refractoryCustomizationsQuery'))

      return false
    },
    enabled: enabled && Boolean(plantUpmId)
  })
}
